// Event Location dropdown select

import { Choices } from "../index";
import { privateEventToggle } from "./privateEvent";
import { refreshPage } from "../index";
import { $ } from "../index";

function eventLocation(selected) {
  $("#event-location-content").addClass("filtering");

  $.ajax({
    url: indexJSVars.ajaxurl,
    type: "POST",
    data: {
      action: "get_event_location_content",
      location_id: selected,
    },
    success: function (response) {
      $("#event-location-content").append(response);

      setTimeout(function () {
        $("#event-location-content > div:not(:last-child)").remove();
        $("#event-location-content").removeClass("filtering");
        privateEventToggle();
        refreshPage();
      }, 300);
    },
  });
}

$(document).on("change", "#event-location-select", function () {
  var selected = $(this).val();
  eventLocation(selected);
});

if (document.querySelector(".m-event-locations")) {
  var select = document.querySelector("#event-location-select");

  var initiallySelected = select.value;
  eventLocation(initiallySelected);

  new Choices(select, {
    itemSelectText: "",
    removeItems: true,
    searchEnabled: false,
    shouldSort: false,
  });

  select.addEventListener(
    "showDropdown",
    function () {
      const dropdownItems = document.querySelectorAll(
        ".choices__list--dropdown .choices__item",
      );

      dropdownItems.forEach((item) => {
        const itemText = item.textContent;
        item.innerHTML = `<span>${itemText}</span>`;
      });
    },
    false,
  );
}
